export default __webpack_public_path__ + "bc9c1466c4d81ab24ed2b6078d0e0100.svg";